import React from 'react';
import { TemplateRenderProps } from './types';
import { SaasTemplate } from './SaasTemplate';
import { ClassicTemplate } from './ClassicTemplate';
import { MinimalTemplate } from './MinimalTemplate';
import { GlassTemplate } from './GlassTemplate';
import { CyberpunkTemplate } from './CyberpunkTemplate';
import { BentoTemplate } from './BentoTemplate';
import { SplitDarkTemplate } from './SplitDarkTemplate';
import { FloatingTemplate } from './FloatingTemplate';
import { VerticalTemplate } from './VerticalTemplate';
import { NeumorphicTemplate } from './NeumorphicTemplate';
import { FeatureRichTemplate } from './FeatureRichTemplate';
import { MonoTemplate } from './MonoTemplate';
import { PlayfulTemplate } from './PlayfulTemplate';
import { CleanStripeTemplate } from './CleanStripeTemplate';
import { SocialHeavyTemplate } from './SocialHeavyTemplate';

export const TemplateDispatcher: React.FC<TemplateRenderProps> = (props) => {
  switch (props.config.template) {
    case 'saas':
      return <SaasTemplate {...props} />;
    case 'classic':
      return <ClassicTemplate {...props} />;
    case 'minimal':
      return <MinimalTemplate {...props} />;
    case 'glass':
      return <GlassTemplate {...props} />;
    case 'cyberpunk':
      return <CyberpunkTemplate {...props} />;
    case 'bento':
      return <BentoTemplate {...props} />;
    case 'split_dark':
      return <SplitDarkTemplate {...props} />;
    case 'floating':
      return <FloatingTemplate {...props} />;
    case 'vertical':
      return <VerticalTemplate {...props} />;
    case 'neumorphic':
      return <NeumorphicTemplate {...props} />;
    case 'feature_rich':
      return <FeatureRichTemplate {...props} />;
    case 'mono':
      return <MonoTemplate {...props} />;
    case 'playful':
      return <PlayfulTemplate {...props} />;
    case 'clean_stripe':
      return <CleanStripeTemplate {...props} />;
    case 'social_heavy':
      return <SocialHeavyTemplate {...props} />;
    default:
      return <SaasTemplate {...props} />;
  }
};
